import { render, staticRenderFns } from "./AboutVasion.vue?vue&type=template&id=0d8b9ba1&scoped=true&"
import script from "./AboutVasion.vue?vue&type=script&lang=js&"
export * from "./AboutVasion.vue?vue&type=script&lang=js&"
import style0 from "./AboutVasion.vue?vue&type=style&index=0&id=0d8b9ba1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8b9ba1",
  null
  
)

export default component.exports